export const typeData = [
  {
    id: 25,
    name: "POTY",
  },
  {
    id: 1,
    name: "SMP",
  },
  {
    id: 2,
    name: "DMP",
  },
  {
    id: 3,
    name: "LCL",
  },
];

export const handicapData = [
  {
    id: 1,
    name: "5%",
  },
  {
    id: 2,
    name: "10%",
  },
  {
    id: 3,
    name: "25%",
  },
  {
    id: 4,
    name: "30%",
  },
  {
    id: 5,
    name: "35%",
  },
  {
    id: 6,
    name: "40%",
  },
  {
    id: 7,
    name: "45%",
  },
  {
    id: 8,
    name: "50%",
  },
  {
    id: 9,
    name: "55%",
  },
  {
    id: 10,
    name: "60%",
  },
  {
    id: 11,
    name: "65%",
  },
  {
    id: 12,
    name: "70%",
  },
  {
    id: 13,
    name: "75%",
  },
  {
    id: 14,
    name: "80%",
  },
  {
    id: 15,
    name: "85%",
  },
  {
    id: 16,
    name: "90%",
  },
  {
    id: 17,
    name: "95%",
  },
  {
    id: 18,
    name: "100%",
  },
];

export const pointSystemData = [
  {
    id: 1,
    name: "25",
  },
  {
    id: 2,
    name: "50",
  },
  {
    id: 3,
    name: "75",
  },
  {
    id: 4,
    name: "Mannual",
  },
];

export const noOfPlayers = [
  {
    id: 1,
    number: "4",
  },
  {
    id: 2,
    number: "8",
  },
  {
    id: 3,
    number: "16",
  },
  {
    id: 4,
    number: "32",
  },
  {
    id: 5,
    number: "64",
  },
  {
    id: 6,
    number: "128",
  },
];

export const scoringMethod = [
  {
    id: 1,
    name: "Best Ball",
  },
  {
    id: 2,
    name: "Best Ball & Aggregate",
  },
];
